import { connect } from 'react-redux'
import { IAppState } from '../../../store/store.model'
import { AudioHome, IAudioHomeStateProps } from './AudioHome.component'

const mapStateToProps = (state: IAppState): IAudioHomeStateProps => ({
  embed: state.currentScTrackEmbed,
})

export default connect(mapStateToProps)(AudioHome)
